




























import { Component, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../../Pi/types'
import { ProxyDelayIntervalType } from '../../../logic/Proxy/ProxyDelayTypes'
import DelayLimit from '../components/DelayLimit.vue'

@Component({
  components: {
    DelayLimit,
  }
})
export default class DelayIntervalType extends UseFields {
  @Prop() delay!: ProxyDelayIntervalType

  get context(): this {
    return this
  }

  get limit(): boolean {
    return !!this.delay.limit
  }

  setOffset(arg: FieldData): FieldData {
    arg.setter = (val) => this.delay.setOffset(val)
    return arg
  }

  setLimit(arg: FieldData): FieldData {
    arg.setter = (val) => this.delay.switchLimit(val)
    return arg
  }
}
